import {createSlice} from '@reduxjs/toolkit'

export const actionMenuSlice = createSlice({
  name: 'prospectSegment',
  initialState: {
    savedProspectsActionMenuOption: '',
    allProspectsActionMenuOption: ''
  },
  reducers: {
    savedProspectsAction: (state, action) => {
      state.savedProspectsActionMenuOption = action.payload
    },
    allProspectsAction: (state, action) => {
      state.allProspectsActionMenuOption = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const {savedProspectsAction, allProspectsAction} = actionMenuSlice.actions

export default actionMenuSlice.reducer
